import BindsReactive from '../../../core/utils/BindsReactive'

let hasEvents = false
let eventTarget = null
let supportsPassiveEvent = false
let BindsFocused = new BindsReactive({
  currentElement: null
})

function checkPassiveEventSupport () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get () {
        supportsPassiveEvent = { passive: true }
      }
    })
    window.addEventListener('ghost', null, opts)
  } catch (e) {}
}

function setKeyboardInteraction ({ keyCode, target }) {
  BindsFocused.currentElement = target
}

function setMouseAndTouchInteraction (event) {
  BindsFocused.currentElement = null
}

function createKeyboardEvents () {
  eventTarget.addEventListener('keyup', setKeyboardInteraction)
}

function createPointerEvents () {
  eventTarget.addEventListener('pointerup', setMouseAndTouchInteraction)
}

function createMSPointerEvents () {
  eventTarget.addEventListener('MSPointerUp', setMouseAndTouchInteraction)
}

function createMouseAndTouchEvents () {
  eventTarget.addEventListener('mouseup', setMouseAndTouchInteraction)

  if ('ontouchend' in window) {
    eventTarget.addEventListener('touchend', setMouseAndTouchInteraction, supportsPassiveEvent)
  }
}

function bindEvents () {
  if (window.PointerEvent) {
    createPointerEvents()
  } else if (window.MSPointerEvent) {
    createMSPointerEvents()
  } else {
    createMouseAndTouchEvents()
  }

  createKeyboardEvents()
}

function createEvents () {
  if (!hasEvents) {
    eventTarget = document.body
    checkPassiveEventSupport()
    bindEvents()
    hasEvents = true
  }
}

export default {
  data: () => ({
    bindsHasFocus: false
  }),
  computed: {
    focusedElement () {
      return BindsFocused.currentElement
    }
  },
  watch: {
    focusedElement (el) {
      this.bindsHasFocus = el === this.$el
    }
  },
  mounted () {
    createEvents()
  }
}
